import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../components/global/Button';
import DesignEditorHeader, {
  DesignEditorHeaderCenterSlot,
  DesignEditorHeaderLeftSlot,
  DesignEditorHeaderRightSlot,
} from '../../../../../components/global/DesignEditor/components/DesignEditorHeader';
import Angle from '../../../../../components/global/Angle';

const propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
};

const PrintProductsGroupConfiguratorHeaderPane = ({ className, onClose }) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <DesignEditorHeader className={classes}>
      <DesignEditorHeaderLeftSlot>
        {onClose && (
          <Button
            btnStyle="link"
            className="print-product-group-configurator-header-return"
            onClick={onClose}
          >
            <Angle direction="left" />
          </Button>
        )}
      </DesignEditorHeaderLeftSlot>

      <DesignEditorHeaderCenterSlot>
        <h3 className="my-1 text-center">Configure your package</h3>
      </DesignEditorHeaderCenterSlot>
      <DesignEditorHeaderRightSlot />
    </DesignEditorHeader>
  );
};

PrintProductsGroupConfiguratorHeaderPane.propTypes = propTypes;

export default PrintProductsGroupConfiguratorHeaderPane;
